module.exports = __webpack_public_path__ + "img/De-T600.32f09210.gif";